export default __webpack_public_path__ + "static/investment-image-9-6d22095e76fdf33f029cb5077036ef59.jpg";